module.exports = __webpack_public_path__ + "static/media/Dusclops_gaussian2.c17ef0b7.png";